import { Controller } from 'stimulus'
import { CountUp } from 'countup.js'

export default class extends Controller {
  static targets = ['toggle', 'yearlyPrice', 'monthlyPrice']

  togglePriceInterval() {
    this.changePaymentInterval()
  }

  changePaymentInterval() {
    if (this.element.classList.contains('pricing--month')) {
      this.element.classList.remove('pricing--month')
      this.element.classList.add('pricing--year')
      this.animateCounters(this.yearlyPriceCounters)
    } else {
      this.element.classList.remove('pricing--year')
      this.element.classList.add('pricing--month')
      this.animateCounters(this.monthlyPriceCounters)
    }
  }

  animateCounters(counters) {
    counters.forEach(counter => {
      counter.reset()
      counter.start()
    })
  }

  get monthlyPriceCounters() {
    if (this._monthlyPriceCounters === undefined || this._monthlyPriceCounters === null) {
      this._monthlyPriceCounters = this.monthlyPriceTargets.map(
        element =>
          new CountUp(element, element.dataset.monthPrice, { duration: 0.5, startVal: element.dataset.yearPrice })
      )
    }
    return this._monthlyPriceCounters
  }

  get yearlyPriceCounters() {
    if (this._yearlyPriceCounters === undefined || this._yearlyPriceCounters === null) {
      this._yearlyPriceCounters = this.yearlyPriceTargets.map(
        element =>
          new CountUp(element, element.dataset.yearPrice, { duration: 0.5, startVal: element.dataset.monthPrice })
      )
    }
    return this._yearlyPriceCounters
  }
}
